import Logo from '../Logo/Logo';
import Menu from './Menu/Menu';

const Header = () => {
  return (
    <div className="w-full fixed top-0 bg-white z-[999]">
      <div className="w-full h-18 flex items-center px-4 2xl:px-40">
        <Logo />
        <Menu />
      </div>
      <div className="text-[12px] p-1 w-full bg-blue-900 text-white text-center absolute w-full">
        {`WELCOME TO MEEST EMPLOYEE HELPER! IF YOU'RE A CLIENT CLICK`}
        <a
          href="https://www.mymeest.ca/MeestPortal/login"
          className="underline ml-[3px]"
          target="_blank"
          rel="noopener noreferrer"
        >
          HERE
        </a>
      </div>
    </div>
  );
};

export default Header;
